import { connect } from "react-redux";
import isArray from "lodash/isArray";
import values from "lodash/values";
import reduce from "lodash/reduce";
import { MAX_USER_IN_GROUP, isFlagged } from "../../../utils";
import {
  Creators,
  isUserSelectedInQueue,
  getSelectedUserInQueue,
} from "../../../reducer";
import Registration from "./Registration";

const collectRegistrations = (previousRegistration, currentRegistration) => {
  if (!previousRegistration) {
    return currentRegistration;
  }

  // toggle select
  if (
    previousRegistration.registrationId === currentRegistration.registrationId
  ) {
    return null;
  }

  //allow to select flagged registration but clear previous selection
  if (isFlagged(currentRegistration) || isFlagged(previousRegistration)) {
    return currentRegistration;
  }

  return [currentRegistration, previousRegistration];
};

const isGroupable = (registrations) => {
  // group users
  if (registrations.length >= 2) {
    const total = reduce(
      registrations,
      (count, registration) => {
        const group = isArray(registration.group)
          ? registration.group
          : values(registration.group);
        return count + group.length;
      },
      0
    );
    if (total <= MAX_USER_IN_GROUP) {
      return true;
    }
  }
  // show error in snackbar
  return false;
};

const registrationIsGrouped = (registration) => {
  return (
    isArray(registration.group) &&
    registration.group.filter((_) => !_.minor).length > 1
  );
};

export default connect(
  (state, ownProps) => ({
    selected: isUserSelectedInQueue(
      state,
      ownProps.registration.registrationId
    ),
    rangeLocation: state.login.location,
    registrationIsGrouped: registrationIsGrouped(ownProps.registration),
    selectedUserInQueue: getSelectedUserInQueue(state),
  }),
  (dispatch) => ({
    onSelectUserInQueue: (location, previousRegistration, registration) => {
      const result = collectRegistrations(previousRegistration, registration);
      if (result && result.length && result.length === 2) {
        if (isGroupable(result)) {
          dispatch(Creators.groupRegistration(location, result));
        }
      } else {
        dispatch(Creators.selectUserInQueue(result));
      }
    },
    onUnGroupRegistration: (location, registration) => {
      dispatch(Creators.unGroupRegistration(location, registration));
    },
    onOpenQueueItemDetail: (location, registration) =>
      dispatch(Creators.openQueueItemDetail(location, registration)),
    onDelete: (location, registrationId) => {
      dispatch(Creators.deleteQueueItem(location, registrationId));
    },
  })
)(Registration);



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Registration/index.js